import type { InterventionRequest, MissionCosts } from 'api/interventionRequestsApi';
import { byHtThenTtc, sumByBasis, type Totals } from 'utils/money';

/** The acceptor's total, else the cheapest and dearest pending technician's; `null` when nothing is priced. */
export const missionTotals = (costs: MissionCosts, requests: InterventionRequest[]): { min: Totals; max: Totals } | null => {
  const totalFor = (request: InterventionRequest): Totals =>
    sumByBasis([costs.tariff, costs.fees.find((fee) => fee.technicianUserId === request.technician.id)]);
  const acceptor = requests.find((request) => request.status === 'accepted');
  const pending = requests.filter((request) => request.status === 'pending');
  const candidates = acceptor ? [totalFor(acceptor)] : pending.length > 0 ? pending.map(totalFor) : [sumByBasis([costs.tariff])];
  const priced = candidates.filter((totals) => Object.keys(totals).length > 0).sort(byHtThenTtc);
  return priced.length > 0 ? { min: priced[0], max: priced[priced.length - 1] } : null;
};
